import getTriggerHash from "./trigger/get-trigger-hash";
import getTriggerName from "./trigger/get-trigger-name";
import getTriggerResolution from "./trigger/get-trigger-resolution";
import getTriggerEvents from "../../listeners/get-trigger-events";
import getTriggerType from "./trigger/get-trigger-type";
import processApplied from "./trigger/process-applied";
import setTriggerParameters from "./set-trigger-parameters";
import isInResolution from "../../../utils/resolutions/is-in-resolution";

/**
 * Process trigger data
 * @param {TriggerProps} trigger
 * @param {TimelineMapProps} timeline
 * @param {MainClassProps} main
 */
const processTrigger = (trigger, timeline, main) => {
  const original = trigger.get("original");

  /** Add processed "timeline" map to trigger */
  trigger.set("timeline", timeline || new Map());

  /** Resolution */
  const resolutionData = getTriggerResolution(original);
  const resolution = resolutionData.get("resolution") || "all";

  /** Trigger data */
  const data = getTriggerName(resolutionData.get("rest"));
  const name = /** @type {String} */ (data.get("name"));
  const hash = getTriggerHash(name, trigger.get("rest"));
  const type = getTriggerType(name);
  const events = getTriggerEvents(type);

  /** Trigger is coordinate-based (scroll, mouse) */
  const isCoordinateBased = ["scroll", "pointer"].includes(type);

  /** Set data to trigger */
  trigger.set("resolution", resolution);
  trigger.set("original-name", name);
  trigger.set("name", hash);
  trigger.set("events", events);
  trigger.set("type", type);
  trigger.set("initial", false);
  trigger.set("pure", new Map());
  trigger.set("alternate-start-time", new Map());
  trigger.set("is-coordinates-based", isCoordinateBased);
  trigger.set("is-in-resolution", isInResolution(resolution));
  trigger.set("is-delayed", false);
  trigger.set("last-angle", 0);
  trigger.set(type, true);

  /** Get default triggers and merge with the custom ones */
  setTriggerParameters(main, trigger, data, type, isCoordinateBased);

  /** Process triggers, that "applies" some values (e.g `class` trigger applies a CSS class) */
  processApplied(trigger, type, name, hash, main);
};

export default processTrigger;
